export const uk = {
    'empty-price': 'Не задана',
    from: 'от',
    to: 'до'
};
